module.exports = __webpack_public_path__ + "img/9_90.01f77de4.png";